import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import HowSenatorsVotedTable from "../components/how-senators-voted-table"
import HowAssemblyMembersVotedTable from "../components/how-assembly-members-voted-table"

export default function Map() {
  return (
    <Layout>
      <SEO title="SB79 Vote" />
      <h1 className="text-center">SB79 Vote</h1>

      <p>
        Here is a simple list of how each member voted on SB79. Are your
        representatives for Local Control?{" "}
      </p>

      <div className="text-xs">
        <h2 className="text-center">Senators</h2>
        <HowSenatorsVotedTable />

        <h2 className="mt-10 mb-3 text-center">Assembly Members</h2>
        <HowAssemblyMembersVotedTable />
      </div>
    </Layout>
  )
}
